module.exports = __webpack_public_path__ + "static/shopify_payment_gateway-6ad245b33d150b6d7ba3447eb4e889a0.svg";